import { ConfirmDetail } from "./types";
import {
  DetailsPanel,
  DetailsLeft,
  DetailIcon,
  DetailPill,
  DetailTextStack,
  DetailTitle,
  DetailSubtitle,
  DetailAmount,
  StatusDot,
} from "./styles";

interface ConfirmDetailsProps {
  detail: ConfirmDetail;
}

/**
 * Compact summary panel for the record a confirmation modal acts on.
 * Shows an optional icon badge or type pill, a title/subtitle stack, and an
 * optional pre-formatted amount. Shared by DeletePopUp and DiscardPopUp.
 */
export const ConfirmDetails: React.FC<ConfirmDetailsProps> = ({ detail }) => {
  const pill = detail.icon ? undefined : detail.pill;
  return (
    <DetailsPanel>
      <DetailsLeft>
        {detail.dot && <StatusDot $tone={detail.dot} />}
        {detail.icon && <DetailIcon>{detail.icon}</DetailIcon>}
        {pill && <DetailPill $variant={pill.variant}>{pill.label}</DetailPill>}
        <DetailTextStack>
          <DetailTitle>{detail.title}</DetailTitle>
          {detail.subtitle && (
            <DetailSubtitle>{detail.subtitle}</DetailSubtitle>
          )}
        </DetailTextStack>
      </DetailsLeft>
      {detail.amount && (
        <DetailAmount $variant={detail.amountVariant}>
          {detail.amount}
        </DetailAmount>
      )}
    </DetailsPanel>
  );
};
